import { Icon } from '@fv/client-components'

import { CarrierTooltip } from '@/components/CarrierTooltip'
import { useBucketCounts } from '@/hooks/opportunities'

export const PendingTendersAlert = ({ className }: { className?: string }) => {
  const pendingTenders = useBucketCounts().data?.pendingTenders

  if (!pendingTenders) return null

  return (
    <CarrierTooltip label="You have tenders that will expire soon">
      <span className={className} role="img" aria-label="Tenders expiring soon">
        <Icon icon="exclamation-triangle" className="ml-2 text-fv-orange" />
      </span>
    </CarrierTooltip>
  )
}
